import { AIGeneratedField } from '@/redux/slices/formAIGenerationSlice'

const DISPLAY_FIELD_TYPES = ['SectionBreak']

export type FieldExtraConfigurableSettings = {
  type: string
  answerSettingMode: string
  answers: {
    apiCode: string
    score: number
    correctAnswer: string | string[] | number
  }[]
  answerExplanation: string | undefined
  enableAnswerExplanation: boolean
}

export type GoodsItem = {
  type: string
  value: string
  name: string
  layout: string
  price: number
  dimensions?: {
    label: string
    value: string
    options: { label: string; value: string }[]
  }[]
  skus?: { price: number; specification: Record<string, unknown> }[]
  position?: number
}[]

export type ReservationItem = {
  apiCode: string
  position: number
  name: string
  description?: string
}

export type BuiltFieldAttributes = {
  type: string
  customizedType?: string | null
  label: string
  notes?: string | null
  validations?: string[]

  choices?:
    | {
        type: 'Choice' | 'OtherChoice'
        name: string
        value: string
        quotaSetting?: number
        quota?: number
        descriptionMode?: 'text' | 'url'
        descriptionText?: string
        descriptionUrl?: string
        position: number
        subChoices?: BuiltFieldAttributes['choices']
      }[]
    | null
  levels?: number | null

  dimensions?: (BuiltFieldAttributes & { enableDimensionCalculation?: boolean })[] | null
  statements?: { apiCode: string; label: string; position: number }[] | null

  goodsItems?: GoodsItem | null
  reservationItems?: ReservationItem[] | null

  likertChoiceStyle?: string | null
  enableAutoPosition?: boolean | null
  latitude?: string | null
  longitude?: string | null
  navAddress?: string | null
  ratingType?: string | null
  ratingMax?: number | null

  extraConfigurableSettings?: FieldExtraConfigurableSettings | null

  // MatrixScaleField specific
  maximumRatingsDisplayText?: string
  minimumRatingsDisplayText?: string
  rangeMin?: number
  position?: number
}

export type BuildFieldFn = (params: Pick<FieldBuilderParams, 'rawField' | 'scene'>) => BuiltFieldAttributes

export type FieldBuilderParams = {
  rawField: AIGeneratedField
  attributes: BuiltFieldAttributes
  scene: string
  buildField: BuildFieldFn
}

export type FieldAttributesBuilder = (params: FieldBuilderParams) => Partial<BuiltFieldAttributes> | undefined

export default function baseFieldBuilder({ rawField }: FieldBuilderParams): BuiltFieldAttributes {
  return {
    type: rawField.type,
    label: rawField.label,
    notes: rawField.notes,
    validations: rawField.required && !DISPLAY_FIELD_TYPES.includes(rawField.type) ? ['presence'] : [],
  }
}
